import { ViewModel,View, ObservableArray } from "binder"
import  { MenuEnabledStatusManipulationView } from "./menuEnabledStatusManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class MenuEnabledStatusManipulationViewModel extends WindowViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.allForms = ObservableArray.create<IForm>();
        this.leafNodes = ObservableArray.create<SingleForm>();
        this.getAllForms();
    }
    GetDefaultView(): View <ViewModel> {
        return new MenuEnabledStatusManipulationView();
    }
    public getTypeId(): string {
        return "VM-EB754EAB-A3D7-4B19-BDEE-6AA752BB4FDF"
    }
    public getTitle(): string {
        return "وضعیت منو";
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set allForms(v: ObservableArray<IForm>) { this._allForms = v; } public get allForms(): ObservableArray<IForm> { return this._allForms;} private _allForms: ObservableArray<IForm>;
    public set leafNodes(v: ObservableArray<SingleForm>) { this._leafNodes = v; } public get leafNodes(): ObservableArray<SingleForm> { return this._leafNodes;} private _leafNodes: ObservableArray<SingleForm>;

    async getAllForms() {
        try{
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/GetAllForms', {
                IncludeDisabled : true
            });
            
            let allForms : SingleForm[] = result.Forms.map(x=>{
                let r = new SingleForm(this);
                r.id = x.Id;
                r.formFullName = x.Name;
                r.position = x.Position;
                return r;
            });
            let root = new FormFolder(this);
            allForms.forEach(x=>root.addForm(x,x.formFullName.split("/")));
            root.sortChildren();
            this.allForms.update(...root.children);
            this.leafNodes.update(...root.getLeafNodes());
            result.Forms.forEach(x=>{
                let relatedForm = this.leafNodes.filter(r=>r.id == x.Id).at(0);
                relatedForm.hasAccess = !x.Disabled;
            })
        }
        catch (ex) {
            console.log(ex);
        }
    }

    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SecurityRawDataServices/UpdateFormsDisableStatus',{
                Forms : this.leafNodes.map(x=>{
                    return {
                        Id : x.id,
                        Disabled : !x.hasAccess
                    }
                })
            });
            this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد.","عملیات موفق");
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("خطا در انجام عملیات.","عملیات نا موفق");
        } finally {
            this.isLoading = false;
        }
    }
}

export interface IForm{
    name:string;
    position : number;
    sortChildren();
    getLeafNodes() : SingleForm[];
    updateAccessRights(value : boolean);
    recheckAccessRights();
    getAccess():boolean;
}
export class FormFolder extends ViewModel implements IForm{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.children = ObservableArray.create<IForm>();
        this.position = 10000000;
        this.indeterminate = false;
    }
    public set parent(v: FormFolder) { this._parent = v; } public get parent(): FormFolder { return this._parent;} private _parent: FormFolder;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set children(v: ObservableArray<IForm>) { this._children = v; } public get children(): ObservableArray<IForm> { return this._children;} private _children: ObservableArray<IForm>;
    public set hasAccess(v: boolean) { 
        let changed = (this._hasAccess !== v);
        this._hasAccess = v; 
        if(changed){
            this.updateAccessRights(v);
            this.recheckAccessRights();
        }
    } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    public set indeterminate(v: boolean) { this._indeterminate = v; } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
    
    addForm(form: SingleForm,pathParts : string[]): void {
        if(form.position<this.position)
            this.position = form.position;

        if(pathParts.length==1){
            form.name = pathParts[0];
            form.parent = this;
            this.children.push(form);
        }else{
            let relatedChild : FormFolder = <FormFolder>this.children.filter(x=>x instanceof FormFolder && x.name == pathParts[0] ).at(0);
            if(relatedChild==null){
                relatedChild  = new FormFolder(this);
                relatedChild.parent = this;
                relatedChild.name = pathParts[0];
                relatedChild.hasAccess = false;
                this.children.push(relatedChild);
            }
            relatedChild.addForm(form,pathParts.slice(1));
        }
    }
    sortChildren(){
        this.children.forEach(x=>x.sortChildren());
        this.children.sort((a,b)=>a.position-b.position);
    }

    getLeafNodes() : SingleForm[]{
        let forms = this.children.flatMap(x=>x.getLeafNodes());
        return forms;
    }

    updateAccessRights(value : boolean){
        if(value === true || value === false){
            this.hasAccess = value;
            this.children.forEach(x=>x.updateAccessRights(value))
        }
    }
    recheckAccessRights(){
        if(this.children.length==0){
            this.hasAccess = false;
            this.indeterminate = false;
        }else if(this.children.every(x=>x.getAccess()===true)){
            this.hasAccess = true;
            this.indeterminate = false;

        }else if(this.children.every(x=>x.getAccess()===false)){
            this.hasAccess = false;
            this.indeterminate = false;
        }else{
            this.indeterminate = true;
        }
        this.parent?.recheckAccessRights();
    }

    getAccess():boolean | null{
        if(this.indeterminate){
            return null;
        }
        return this.hasAccess;
    }

}
export class SingleForm extends ViewModel implements IForm{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.indeterminate = false;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set parent(v: FormFolder) { this._parent = v; } public get parent(): FormFolder { return this._parent;} private _parent: FormFolder;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set formFullName(v: string) { this._formFullName = v; } public get formFullName(): string { return this._formFullName;} private _formFullName: string;
    public set hasAccess(v: boolean) { 
        let changed = (this._hasAccess !== v);
        this._hasAccess = v; 
        if(changed){
            this.updateAccessRights(v);
            this.recheckAccessRights();
        }
    } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    public set indeterminate(v: boolean) { this._indeterminate = v; } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
    public set children(v: ObservableArray<SingleForm>) { this._children = v; } public get children(): ObservableArray<SingleForm> { return this._children;} private _children: ObservableArray<SingleForm>;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    
    sortChildren(){}
    getLeafNodes() : SingleForm[]{
        return [this];
    }

    updateAccessRights(value: boolean) {
        this.hasAccess = value;
    }
    recheckAccessRights() {
        this.parent?.recheckAccessRights();
    }
    getAccess(): boolean {
        return this.hasAccess;
    }

}
